<template>
  <v-container grid-list-lg fluid class="pa-0">
    <supplier-rates-edit-list
      :supplier-id="supplierId"
      :services="services"
      :rate-types="rateTypes"
      :agent-groups="agentGroups"
      :supplier="supplier"
    ></supplier-rates-edit-list>
    <v-layout v-if="debug">
      <p>Debug</p>
      <code>{{ services }}</code>
    </v-layout>
  </v-container>
</template>

<script>
import DatesRangePicker from "../../../shared/DatesRangePicker";
import GtMultiSelect from "../../../shared/GtMultiSelect";
import gql from "graphql-tag";
import SupplierRatesEditList from "./SupplierRatesEditList";
import EventBus from "../../../../../store/event-bus";

const moment = require("moment");

export const QUERY = gql`
  query ($supplierId: ID!) {
    rateTypes(first: 100) {
      totalCount
      edges {
        node {
          id
          code
          name
          includePax
        }
      }
    }
    agentGroups(
      filter: { isAgent: false }
      orderBy: { fieldName: "name", direction: ASC }
    ) {
      edges {
        node {
          id
          name
        }
      }
    }
    supplier(id: $supplierId) {
      id
      defaultRateTypeCode
      currencyCode
      extrasChildPrice
      services(orderBy: { fieldName: "name", direction: ASC }) {
        totalCount
        edges {
          node {
            id
            name
            notInUse
            code
          }
        }
      }
    }
  }
`;

export default {
  name: "SupplierRatesEdit",

  components: {
    SupplierRatesEditList,
    DatesRangePicker,
    GtMultiSelect,
  },

  props: {
    supplierId: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      dateFrom: moment().subtract(1, "year").toISOString(true),
      dateTo: null,
      debug: false,
      selectedServices: [],
      selectedAgentGroup: "",
      ratesData: null,
    };
  },

  computed: {
    agentGroups() {
      if (this.ratesData) {
        return [
          { name: "All Groups", id: "" },
          ...this.ratesData.agentGroups.edges.map((a) => a.node),
        ];
      } else {
        return [];
      }
    },
    services() {
      if (this.ratesData) {
        return this.ratesData.supplier.services.edges.map((s) => s);
      } else {
        return [];
      }
    },
    supplier() {
      if (this.ratesData) {
        return { ...this.ratesData.supplier };
      } else {
        return {};
      }
    },
    rateTypes() {
      if (this.ratesData) {
        return this.ratesData.rateTypes.edges.map((rt) => rt.node);
      } else {
        return [];
      }
    },
    dateFromRangeStart() {
      return moment().subtract(5, "years").toISOString(true);
    },
    dateToRangeEnd() {
      return moment().add(5, "years").toISOString(true);
    },
  },

  methods: {
    onDatesRangeSelected(data) {
      this.dateTo = data.dateTo;
      this.dateFrom = data.dateFrom;
    },
    refetchSupplier() {
      if (this.$apollo.queries.supplier != null) {
        this.$apollo.queries.supplier.refetch();
      }
    },
  },

  apollo: {
    supplier: {
      query: QUERY,
      variables() {
        return {
          supplierId: this.supplierId,
        };
      },
      skip() {
        return this.supplierId ? false : true;
      },
      fetchPolicy: "network-only",
      result({ data }) {
        this.ratesData = data;
      },
    },
  },
  mounted() {
    EventBus.$on("supplier-services-change", () => {
      this.refetchSupplier();
    });
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/supplier-rates/edit/SupplierRatesEdit.vue